import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { makeStyles } from '@material-ui/core/styles';
import Moment from 'react-moment'
import clsx from 'clsx';
import { Grid, Button, Typography } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { ListMisuse, DefaultMisUseResult, GetMemberSummaryMisUse, ListMisuseNotes, UpdateMisUse } from '../_service/member';
import { IMemberSummary, IMisUseNote, MisUseQuery, IMisUseRecord, IMisUseUpdateRequest } from '../_types/member';
import { IPagedResults } from '../_types/search';
import { EnumToString } from '../_util/Utility';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Icon, { SupportedIcons } from '../common/Icon';


interface Props {   

};

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        },
    deletedPlan: {
        textDecoration: "line-through"
    },
    table: {
        minWidth: 400,
    },
    lbl: {
        color: theme.palette.primary.main,
        marginRight: theme.spacing(1)
    },
    lblRight: {
        color: theme.palette.primary.main,
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },
    tr: {
        background: theme.palette.grey[100],
        '&:hover': {
          background: theme.palette.grey[300],
          cursor: "pointer"
        }
      },
    thisMem: {
        background: theme.palette.grey[300]
    },
    remaining: {
        marginTop: theme.spacing(1)
    }
//     home: { color: "primary" },
//     away: { color: theme.palette.grey[900] }
}));

const MisUse: React.FC<Props> = (prop: Props) => {
    
    const { user } = useContext(AuthContext);
    const [ results, setResult ] = useState<IPagedResults<IMisUseRecord>>(DefaultMisUseResult);
    const [ edit, setEdit ] = useState<IMisUseRecord | null>(null);
    const [ memSum, setMemSum ] = useState<IMemberSummary | null>(null);
    const [ notes, setNotes ] = useState<IMisUseNote[] | null>(null);
    const [ note, setNote ] = useState<string | null>(null);
    const [ userId, setUserId ] = useState<number | null>(null);
    const classes = useStyles();
    //let { id } = useParams<{id: string | undefined}>();


    //load results on load
    React.useEffect(() => {
        _refreshMisuse(null, null);


    }, []);

    const _refreshMisuse = (key: string | null, user_id: number | null) => {
        let currentUser = user;
        let location_id: number | null = null;

        let keys: string[] | null = null;
        if (key && key.length > 0) {
            keys = [ key ]
        };

        if (currentUser.currentLocation) {
            location_id = currentUser.currentLocation.id;
        }

        //For now pagesize does nothing
        let q: MisUseQuery = {
            location_id: location_id,
            PageSize: 20,
            Reverse: false,
            StartFromKeys: keys,
            status_cn: null,
            userId: user_id,
            KeyFields: ["id"],
            Page: null
        }

        ListMisuse(q).then(r => {
            setEdit(null);
            setResult({...r});
        })
    }

    React.useEffect(() => {
        _refreshMisuse(null, userId);


    }, [user]);

    const _getMemberSummary = (id: number) => {

        //let toReturn: IMemberSummary | null = null;
        GetMemberSummaryMisUse(id).then(r => setMemSum(r));
        
    };

    const _getMisUseNotes = (id: number) => {
        //let toReturn: IMisUseNote[] | null = null;
        ListMisuseNotes(id).then(r => setNotes(r))
    }

    const _getActions = () => {
        if (edit) {
            switch (edit.status_cn) {
                //if created on needs_review, take, first, second, final, disregard, not miuse
                case "misusestatus.created":
                case "misusestatus.needs_review":
                    return (
                        <React.Fragment>
                            <Button onClick={() => { _handleDialog("misusestatus.in_review"); }}>Take</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.first_warning"); }}>Send First Warning</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.second_warning"); }}>Send Second Warning</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.cancel_and_ban"); }}>Cancel and Ban</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.final_warning"); }}>Send Final Warning</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.disregard"); }}>Disregard</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.update_plate"); }}>Update Plate</Button>
                            <Button onClick={() => { _handleDialog(null); }}>{(note && note.length > 0) ? "Save" : "Close" }</Button>
                        </React.Fragment>
                    )
                //if in review, untake, first, second, final, disregard, not misuse
                case "misusestatus.in_review":
                    return (
                        <React.Fragment>
                            {   (user.id === edit.update_user_id) &&
                                ( <Button onClick={() => { _handleDialog("misusestatus.needs_review"); }}>UnTake</Button> )
                            }
                            <Button onClick={() => { _handleDialog("misusestatus.first_warning"); }}>Send First Warning</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.second_warning"); }}>Send Second Warning</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.cancel_and_ban"); }}>Cancel and Ban</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.final_warning"); }}>Send Final Warning</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.disregard"); }}>Disregard</Button>
                            <Button onClick={() => { _handleDialog("misusestatus.update_plate"); }}>Update Plate</Button>
                            <Button onClick={() => { _handleDialog(null); }}>{(note && note.length > 0) ? "Save" : "Close" }</Button>
                        </React.Fragment>
                    )
                default:
                    return (
                        <React.Fragment>
                            <Button onClick={() => { _handleDialog(null); }}>{(note && note.length > 0) ? "Save" : "Close" }</Button>
                        </React.Fragment>
                    )
                
            }
        }
    }

    const _handleDialog = (action: string | null) => {
        if (edit) {
            if (action && action.length > 0) {
                let status = action;
                //if "first"
                let req: IMisUseUpdateRequest = {
                    misuse_id: edit?.id,
                    note: note,
                    status_cn: status
                    
                };
                UpdateMisUse(req).then(r => { _refreshMisuse(null, userId) });            
                

            } else {
                if (note && note.length > 0) {
                    let req: IMisUseUpdateRequest = {
                        misuse_id: edit?.id,
                        note: note,
                        status_cn: edit.status_cn
                        
                    };
                    UpdateMisUse(req).then(r => { _refreshMisuse(null, userId) });   
                } else {
                    //just close
                    setEdit(null);
                }
            }
        }
        
    }

    const _notesView = () => {
        if (notes != null) {

            return (
                <React.Fragment>
                    <Typography variant="h6">Notes</Typography>
                    <TableContainer component={Paper}>
                        <Table className={classes.table} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Note</TableCell>
                                    <TableCell align="left">Created By</TableCell>
                                    <TableCell align="left">Created Date</TableCell>
                                    <TableCell align="left">Status</TableCell>
                                    
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {notes?.map(row => (
                                    <TableRow key={row.id}>
                                    
                                        <TableCell align="left">{row.note}</TableCell>
                                        <TableCell align="left">{row.creator}</TableCell>
                                        <TableCell align="left">{<Moment date={row.created_at} format="YYYY-MM-DD hh:mm"></Moment>}</TableCell>
                                        <TableCell align="left">{EnumToString(row.status_cn)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </React.Fragment>

            )

        }
    }

    const _memberSummaryView = () => {

        if (memSum != null && edit != null && memSum.memberships != null) {
            let thisMem = memSum.memberships.find(g => g.id === edit.membership_id);

            return (
                <Grid container direction="column">
                    <Grid item>
                    <Grid container direction="row">
                            <Grid item><span className={classes.lbl}>Name:</span> {memSum.name} </Grid>
                            <Grid item><span className={classes.lbl}>Id: </span> {memSum.uuid} </Grid>
                            <Grid item><span className={classes.lblRight}>Email:</span> {memSum.email} </Grid>
                            <Grid item><span className={classes.lblRight}>Phone:</span> {memSum.phone} </Grid>
                            
                        </Grid> 
                    </Grid>
                    {/* <Grid item>
                        <Grid container direction="row">
                            <Grid item><span className={classes.lbl}>Location:</span> {thisMem?.location_name}</Grid>
                            <Grid item><span className={classes.lblRight}>Plan:</span> {thisMem?.plan_name}</Grid>
                            <Grid item><span className={classes.lblRight}>Created:</span><Moment date={thisMem?.created} durationFromNow></Moment></Grid>
                            <Grid item><span className={classes.lblRight}>Current Plate:</span> {thisMem?.plate}</Grid>
                            <Grid item>
                                {thisMem?.cancelled && (<Chip color="secondary" variant="outlined" size="small" label="Cancelled"></Chip>)}
                                {thisMem?.frozen && (
                                    <Chip color="secondary" variant="outlined" size="small" label="Frozen"></Chip>
                                    
                                )}
                            </Grid>
                            
                        </Grid>
                    </Grid> */}
                    <Grid item>
                        <Grid container direction="row">
                            <Grid item><span className={classes.lbl}>Total Usage:</span> {thisMem?.all_time_usage}</Grid>
                            <Grid item><span className={classes.lblRight}>Last Thirty Days:</span> {thisMem?.last_thirty_usage}</Grid>
                            { thisMem?.last_use && (
                            <Grid item><span className={classes.lblRight}>Last Usage</span><Moment date={thisMem?.last_use?.toString()} format="YYYY-MM-DD hh:mm"></Moment></Grid>
                            )}
                            { thisMem?.first_use && (
                            <Grid item><span className={classes.lblRight}>First Usage</span><Moment date={thisMem?.first_use?.toString() } format="YYYY-MM-DD hh:mm"></Moment></Grid>
                            )}
                        </Grid>
                    </Grid>
                    <Grid item>
                        <br/>
                        <Typography variant="h6">MisUse History</Typography>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small">
                                <TableHead>
                                    <TableRow>
                                        
                                        <TableCell align="left">Membership Location</TableCell>
                                        <TableCell align="left">Usage Location</TableCell>
                                        <TableCell align="left">Plate On File</TableCell>
                                        <TableCell align="left">Plate Observed</TableCell>
                                        <TableCell align="left">Suggestion</TableCell>
                                        <TableCell align="left">Occurred (Wash Time)</TableCell>
                                        <TableCell align="left">Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {memSum.misuse?.map(row => (
                                        <TableRow key={row.id} className={clsx(row.id === edit.id && classes.thisMem)}>
                                            
                                            <TableCell align="left">{row.location_name}</TableCell>
                                            <TableCell align="left">{row.location_occurred_name}</TableCell>
                                            <TableCell align="left">{row.plate_on_file}</TableCell>
                                            <TableCell align="left">{row.plate_observed}</TableCell>
                                            <TableCell align="left">{row.suggestion}</TableCell>
                                            <TableCell align="left"><Moment date={row.event_dt} format="YYYY-MM-DD hh:mm"></Moment></TableCell>
                                            <TableCell align="left">{EnumToString(row.status_cn)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item>
                        <br/>
                        <Typography variant="h6">Memberships</Typography>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">Id</TableCell>
                                        <TableCell align="left">Location</TableCell>
                                        <TableCell align="left">Plan</TableCell>
                                        <TableCell align="left">Created</TableCell>
                                        <TableCell align="left">Plate On File</TableCell>
                                        <TableCell align="left">Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {memSum.memberships?.map(row => (
                                        <TableRow key={row.id} className={clsx(thisMem?.id === row.id && classes.thisMem)}>
                                            <TableCell align="left">{row.uuid}</TableCell>
                                            <TableCell align="left">{row.location_name}</TableCell>
                                            <TableCell align="left">{row.plan_name}</TableCell>
                                            <TableCell align="left"><Moment date={row.created} format="YYYY-MM-DD hh:mm"></Moment></TableCell>
                                            <TableCell align="left">{row.plate}</TableCell>
                                            <TableCell align="left">
                                                {thisMem?.cancelled && (<Chip color="secondary" variant="outlined" size="small" label="Cancelled"></Chip>)}
                                                {thisMem?.frozen && (
                                                    <Chip color="secondary" variant="outlined" size="small" label="Frozen"></Chip>
                                                )}
                                                {(!thisMem?.frozen && !thisMem?.cancelled) && (
                                                    <Chip color="primary" variant="outlined" size="small" label="Active"></Chip>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            )

        } else {
            return (<span></span>);
        }

    }

    const _reviewMisuse = (key: string) => {


        setMemSum(null);
        if (results != null && results.Results != null) {
            let toEdit = results.Results.find(g => g.Keys[0] === key);
            if (toEdit != null) {

                setNote(null);
                
                setEdit({...toEdit.Result});
                _getMemberSummary(toEdit.Result.user_id);
                _getMisUseNotes(toEdit.Result.id);
            }
        }
    }

    return (
        <React.Fragment>
        <Grid item>
            <Grid item className={classes.remaining}>
                <Typography>Total Results: {results.Remaining} </Typography>
            </Grid>
            { userId ? (
            <Grid item className={classes.remaining}>
                <Typography>Filtered on  User Id: {userId} - <Button variant='text' onClick={() => {setUserId(null); _refreshMisuse(null, null)}}>Remove</Button></Typography>
            </Grid>
            ) : (
                <span></span>
            )}
            <TableContainer component={Paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Member Name</TableCell>
                            <TableCell align="left">Member UUID</TableCell>
                            <TableCell align="left">Location</TableCell>
                            <TableCell align="left">Plate On File</TableCell>
                            <TableCell align="left">Plate Observed</TableCell>
                            <TableCell align="left">Suggestion</TableCell>
                            <TableCell align="left">Occurred (Wash Time)</TableCell>
                            <TableCell align="left">Status</TableCell>
                            <TableCell align="left">Updated By</TableCell>
                            <TableCell align="left">Has Notes</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results.Results?.map(row => (
                            <TableRow onClick={() => _reviewMisuse(row.Keys[0])} className={classes.tr} key={row.Keys[0]}>
                                <TableCell align="left">{row.Result.user_name} 
                                    {userId == null ? <IconButton 
                                        disabled={userId != null} 
                                        onClick={(e) => {setUserId(row.Result.user_id); _refreshMisuse(null, row.Result.user_id); e.stopPropagation(); }}>
                                        <Icon fontSize="small" iconName={SupportedIcons.Filter}/>
                                    </IconButton>: <span></span>}
                                </TableCell>
                                <TableCell align="left">{row.Result.membership_uuid}</TableCell>
                                <TableCell align="left">{row.Result.location_name}</TableCell>
                                <TableCell align="left">{row.Result.plate_on_file}</TableCell>
                                <TableCell align="left">{row.Result.plate_observed}</TableCell>
                                <TableCell align="left">{row.Result.suggestion}</TableCell>
                                <TableCell align="left"><Moment date={row.Result.event_dt} format="YYYY-MM-DD hh:mm" ></Moment></TableCell>
                                <TableCell align="left">{EnumToString(row.Result.status_cn)}</TableCell>
                                <TableCell align="left">{row.Result.update_user_name}</TableCell>
                                <TableCell align="left">{row.Result.note_count > 0 ? "Yes": "No"}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </TableContainer>
        </Grid>
        <Dialog fullWidth maxWidth="lg" scroll="paper" open={edit != null}>
            <DialogTitle>Review Misuse</DialogTitle>

            <DialogContent>
                { memSum !== null  && (
                    <React.Fragment>
                        
                        {_memberSummaryView()}
                        <br/>
                        {_notesView()}
                        <br/>
                        <Grid container direction="column">
                            <Grid item>
                                <TextField multiline rows={4} defaultValue="" onChange={(val:React.ChangeEvent<HTMLInputElement>) => setNote(val.target.value)} label="Add Note" fullWidth/>

                            </Grid>
                        </Grid>
                    </React.Fragment>
                )
                }
            </DialogContent>
            <DialogActions>
                {_getActions()}
                
            </DialogActions>

   
            
            </Dialog>
        </React.Fragment>
)
}

export default MisUse;